import React from "react"
import ReactDevicePreview from "react-device-preview"

const MobileScreen = ({
  backgroundImage,
  backgroundColor,
  children,
  itemId,
  scale = "1",
}) => {
  const displayStyle = {}

  displayStyle.backgroundImage =
    backgroundImage && backgroundImage != "null"
      ? `url('${backgroundImage}')`
      : "none"

  if (backgroundColor) {
    displayStyle.backgroundColor = backgroundColor
  }

  const getStyle = () => {
    return `
            ${itemId ? `#${itemId}` : ""} .marvel-device .screen {
                background-color: ${backgroundColor};
                background-image: ${
                  backgroundImage && backgroundImage != "null"
                    ? `url('${backgroundImage}')`
                    : "none"
                };
                background-repeat: no-repeat;
                background-position: center; 
                background-size: cover;
            }
        `
  }

  return (
    <>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: getStyle(),
        }}
      />
      <div id={itemId}>
        <ReactDevicePreview scale={scale} device="iphonex">
          <div className="mobile-content">{children}</div>
        </ReactDevicePreview>
      </div>
    </>
  )
}

export default MobileScreen
